import { createAction, props } from '@ngrx/store';
import { Administrator } from 'src/app/core/models/administrator.model';
import { Customer } from 'src/app/core/models/customer.model';
import { Credentials, LoginResponse } from './user.reducers';
import {AllauthError, AllAuthLoginResponse, ReauthenticateResponse} from '../../core/models/allauth.model';

/**
 * Actions
 *
 * [Auth] Login
 * [Auth] Login Success
 * [Auth] Login Failure
 * [Auth] Redirect
 */

export const login = createAction('[User] Login', props<Credentials>());

export const loginSuccess = createAction(
  '[User] Login Success',
  props<LoginResponse>()
);

export const loginFailure = createAction(
  '[User] Login Failure',
  props<{ error: AllauthError }>()
);

export const storeSessionToken = createAction(
  '[User] Store Session Token',
  props<{sessionToken: string}>()
);

export const mfaAuthentication = createAction('[User] MFA Authentication', props<{code: string}>());

export const mfaAuthenticationSuccess = createAction(
  '[User] MFA Authentication Success',
  props<AllAuthLoginResponse>()
);

export const mfaAuthenticationFailure = createAction(
  '[User] MFA Authentication Failure',
  props<{ error: AllauthError }>()
);

export const reauthenticateRedirect = createAction('[User] Reauthenticate Redirect');

export const reauthenticate = createAction('[User] Reauthenticate', props<{password: string}>());

export const reauthenticateSuccess = createAction(
  '[User] Reauthenticate Success',
  props<ReauthenticateResponse>()
);

export const reauthenticateFailure = createAction(
  '[User] Reauthenticate Failure',
  props<{ error: AllauthError }>()
);

export const changePassword = createAction('[User] Change Password', props<{oldPassword: string, newPassword: string}>());

export const changePasswordSuccess = createAction(
  '[User] Change Password Success',
  props<AllAuthLoginResponse>()
);

export const changePasswordFailure = createAction(
  '[User] Change Password Failure',
  props<{ error: AllauthError }>()
);

export const logout = createAction('[User] Logout');

export const logoutSession = createAction('[User] Logout Session');

export const loginRedirect = createAction('[User] Login Redirect');

export const totpLoginRedirect = createAction('[User] TOTP Login Redirect');

export const getCustomer = createAction('[User] Get Customer', props<Number>());

export const getCustomerSuccess = createAction(
  '[User] Get Customer Success',
  props<Customer>()
);

export const getCustomerFailure = createAction(
  '[User] Get Customer Failure',
  props<{ error: any }>()
);

export const getCustomerPermissions = createAction(
  '[User] Get Customer Permissions',
  props<Number>()
);

export const getCustomerPermissionsSuccess = createAction(
  '[User] Get Customer Permissions Success',
  props<{ permissions: string[] }>()
);

export const getCustomerPermissionsFailure = createAction(
  '[User] Get Customer Permissions Failure',
  props<{ error: any }>()
);

export const getAdministratorsSuccess = createAction(
  '[User] Get Administrators Success',
  props<{ administrators: Administrator[] }>()
);

export const getAdministratorsFailure = createAction(
  '[User] Get Administrators Failure',
  props<{ error: any }>()
);

export const refreshToken = createAction('[User] Refresh Token');

export const refreshTokenSuccess = createAction(
  '[User] Refresh Token Success',
  props<{ token: string }>()
);

export const refreshTokenFailure = createAction(
  '[User] Refresh Token Failure',
  props<{ error: any }>()
);
